'use strict';

var _ = require('lodash');
var ContributingFBCsGridAggregationFactory = function ContributingFBCsGridAggregationFactory(DataAggregationFactory, momentService) {
  function ContributingFBCsGridAggregation(sourceType, targetType) {
    sourceType = sourceType || 'fares-mode';
    targetType = targetType || 'contributing-fbcs';
    DataAggregationFactory.call(this, sourceType, targetType);
  }
  function calculateFlightRangesField(includeFlightRanges) {
    if (includeFlightRanges) {
      return _.map(includeFlightRanges, function (range) {
        return range.begin + '-' + range.end;
      }).join(', ');
    } else {
      return undefined;
    }
  }
  ContributingFBCsGridAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ContributingFBCsGridAggregation.constructor = ContributingFBCsGridAggregation;
  ContributingFBCsGridAggregation.prototype.aggregate = function (data) {
    var results = [];
    var fields = ['advancePurchaseDay', 'applicableDateRangeBegin', 'applicableDateRangeEnd', 'bookingClass', 'destination', 'fare', 'spos', 'fareBasisCode', 'fareType', 'fim', 'includeFlightRanges', 'flightNbrList', 'includeFlights', 'limitUpTo', 'mappedFare', 'market', 'origin', 'posCountry', 'surcharge', 'cat12Surcharge', 'traffic', 'userFare', 'userTraffic', 'latestChanges', 'lastProcessedDateMoment', 'nbrOfObs', 'fareId', 'fareDirectionIndicator', 'roundTripIndicator', 'useForAveraging', 'fareBasisGroup'];
    if (data) {
      for (var index = 0, dataLength = data.length; index < dataLength; index++) {
        var element = data[index];
        if (!element.sellDateRange || Array.isArray(element.sellDateRange) && element.sellDateRange.length === 0) {
          element.sellDateRange = [{
            end: null,
            begin: null
          }];
        }
        if (Array.isArray(element.includeFlights)) {
          element.includeFlights = element.includeFlights.join(', ');
        }
        if (Array.isArray(element.includeFlightRanges)) {
          element.includeFlightRanges = calculateFlightRangesField(element.includeFlightRanges);
        }
        for (var sellDateRangeIndex = 0, sellDateRangeLength = element.sellDateRange.length; sellDateRangeIndex < sellDateRangeLength; sellDateRangeIndex++) {
          var row = {};
          for (var fieldsIndex = 0, fieldsLength = fields.length; fieldsIndex < fieldsLength; fieldsIndex++) {
            row[fields[fieldsIndex]] = element[fields[fieldsIndex]];
          }
          row.sellStart = momentService.of(element.sellDateRange[sellDateRangeIndex].begin, momentService.FIELD.SELL_DATE_RANGE);
          row.sellEnd = momentService.of(element.sellDateRange[sellDateRangeIndex].end, momentService.FIELD.SELL_DATE_RANGE);
          results.push(row);
        }
      }
      return results;
    } else {
      return [];
    }
  };
  return ContributingFBCsGridAggregation;
};
ContributingFBCsGridAggregationFactory.$inject = ['DataAggregationFactory', 'MomentService'];
module.exports = ContributingFBCsGridAggregationFactory;